"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "profile-edit-body"
  }, [_c('div', {
    staticClass: "edit-mode-tabs"
  }, [_c('button', {
    staticClass: "mode-tab",
    class: {
      active: _vm.editMode === 'public'
    },
    on: {
      "click": function ($event) {
        _vm.editMode = 'public';
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" PÚBLICO ")]), _c('button', {
    staticClass: "mode-tab",
    class: {
      active: _vm.editMode === 'anonymous'
    },
    on: {
      "click": function ($event) {
        _vm.editMode = 'anonymous';
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-secret"
  }), _vm._v(" ANÓNIMO ")])]), _vm.editMode === 'public' ? [_c('div', {
    staticClass: "edit-section"
  }, [_c('h3', [_vm._v("Información del Perfil")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre del canal")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.profileData.name,
      expression: "profileData.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Ej: Luna_Vip"
    },
    domProps: {
      "value": _vm.profileData.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.profileData, "name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Handle (@usuario)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.profileData.handle,
      expression: "profileData.handle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "@usuario_oficial"
    },
    domProps: {
      "value": _vm.profileData.handle
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.profileData, "handle", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Descripción corta (Bio)")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.profileData.bio,
      expression: "profileData.bio"
    }],
    attrs: {
      "placeholder": "Describe tu contenido para tus fans..."
    },
    domProps: {
      "value": _vm.profileData.bio
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.profileData, "bio", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "edit-section"
  }, [_c('h3', [_vm._v("Diseño y Apariencia")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Color del Banner principal")]), _c('div', {
    staticClass: "color-picker-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.profileData.bannerColor,
      expression: "profileData.bannerColor"
    }],
    staticClass: "color-input",
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": _vm.profileData.bannerColor
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.profileData, "bannerColor", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "color-code"
  }, [_vm._v(_vm._s(_vm.profileData.bannerColor))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Foto de Perfil (URL)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.profileData.avatar,
      expression: "profileData.avatar"
    }],
    attrs: {
      "type": "text",
      "placeholder": "https://url-de-tu-foto.cl"
    },
    domProps: {
      "value": _vm.profileData.avatar
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.profileData, "avatar", $event.target.value);
      }
    }
  })])])] : [_c('div', {
    staticClass: "edit-section anonymous-section"
  }, [_c('h3', [_vm._v("Información Anónima")]), _c('p', {
    staticClass: "section-note"
  }, [_vm._v("Esta información solo será visible para fines administrativos o si eliges interactuar de forma privada.")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Usuario")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.anonymousData.user,
      expression: "anonymousData.user"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Ej: Usuario_Real"
    },
    domProps: {
      "value": _vm.anonymousData.user
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.anonymousData, "user", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nick anónimo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.anonymousData.anon_nick,
      expression: "anonymousData.anon_nick"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Ej: Sombra_01"
    },
    domProps: {
      "value": _vm.anonymousData.anon_nick
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.anonymousData, "anon_nick", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Correo Electrónico")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.anonymousData.email,
      expression: "anonymousData.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "tu@correo.com"
    },
    domProps: {
      "value": _vm.anonymousData.email
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.anonymousData, "email", $event.target.value);
      }
    }
  })])])], _c('div', {
    staticClass: "edit-actions"
  }, [_c('button', {
    staticClass: "save-btn",
    on: {
      "click": _vm.saveChanges
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" GUARDAR CAMBIOS ")])])], 2);
};
var staticRenderFns = exports.staticRenderFns = [];